// extracted by mini-css-extract-plugin
export var readonly = "_gp-1";
export var star = "_gp-0";